// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_3pHM-Hu91zGsDm3pnZCKzD","body":"_2jWHyVCFhswsgDOzz4Ibax","header":"_1MF4CXjbf7TIjK_PkY7Rbm","title":"_2l8fmRhe-uJoUVjaODIygI","subTitle":"_2G8GcFckOvf2_HpuyYivc6"};